var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiyedAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.016,
    height: 11.94,
    viewBox: "0 0 12.016 11.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MirrorFly_tick",
    transform: "translate(-1.1 -1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star-2",
    d: "M7.07,12.36l-1.436.68-.982-1.285L3.065,11.68l-.227-1.587L1.4,9.337,1.931,7.75,1.1,6.465,2.234,5.332,2.082,3.745l1.587-.453.6-1.511,1.587.3L7.07,1.1l1.285.982,1.511-.3.68,1.511,1.511.453-.076,1.587,1.134,1.134L12.284,7.75l.453,1.587-1.36.756-.3,1.587-1.587.076L8.506,13.04Z",
    fill: "#00da60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-Icon",
    d: "M11.121,7.1l-.68-.6-3.1,3.1L5.68,8.011,5,8.692l2.267,2.267Z",
    transform: "translate(-0.953 -1.319)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiyedAccount);
export default __webpack_public_path__ + "static/media/verifiyed_account.060e87cc1c4112c44c3296a821c180fe.svg";
export { ForwardRef as ReactComponent };